module.exports = __webpack_public_path__ + "static/media/Group130.6fa31037.png";